__turbopack_context__.v({
  "buttons": "MobileScreens-module-scss-module__kEQb3a__buttons",
  "content": "MobileScreens-module-scss-module__kEQb3a__content",
  "divider": "MobileScreens-module-scss-module__kEQb3a__divider",
  "linkWrapper": "MobileScreens-module-scss-module__kEQb3a__linkWrapper",
  "mobileMenuStickBottom": "MobileScreens-module-scss-module__kEQb3a__mobileMenuStickBottom",
  "mobileMenuTextButton": "MobileScreens-module-scss-module__kEQb3a__mobileMenuTextButton",
  "topGradient": "MobileScreens-module-scss-module__kEQb3a__topGradient",
});
